import { Close } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton, Stack, Typography } from '@lyearn/ui';

import { maxW280 } from '../../../PraiseCard/styles';
import { SelectedSkillPillProps } from './types';

const SelectedSkillPill: React.FC<SelectedSkillPillProps> = (props) => {
  const { label, onRemove } = props;

  return (
    <Stack
      alignItems="center"
      className={cn('mb-8 h-32 rounded-full border border-divider pe-4 ps-12 me-8', maxW280)}>
      <Typography
        className="break-all"
        color="text-text-secondary"
        numberOfLines={1}
        variant="body-short-02">
        {label}
      </Typography>
      <LinkButton Icon={Close} size="small" onClick={onRemove} />
    </Stack>
  );
};

export default SelectedSkillPill;
